import axiosInstance from "./axiosConfig";
import { handleAPIError } from "./utils/errors";
import type { Entitlements } from "../types/entitlements";

export type SessionIdentityDTO = {
  uid: string;
  userType: "lawyer";
};

export type SessionLawyerDTO = {
  uid: string;
  email: string;
  firstName: string;
  middleName: string;
  lastName: string;
  practiceName: string;
  lawFirm: string;
  law_firm_id?: string | null;
  role: string;
  hasAcceptedTerms: boolean;
  hideQualityReview: boolean;
  betaFeatures: string[];
  hiddenPrompts?: string[];
  website: string;
  time_tracking_enabled?: boolean;
  legacyDrafting?: boolean;
  pronouns: string;
  title: string;
  address: string;
  state: string;
  city: string;
  zipcode: string;
  phone: string;
  subscription?: unknown;
  exhibitListFormat?: string | null;
  organizeInstruction?: string;
  documentTitleStyle?: string;
  subagentModel?: string;
  subagentThinking?: boolean;
  /** The guided first run; `status` is null for members from before it. */
  onboarding?: { status: string | null } | null;
  created_at?: string | null;
  updated_at?: string | null;
};

export type SessionMeResponseDTO = {
  identity: SessionIdentityDTO;
  lawyer: SessionLawyerDTO;
  // Absent on older backends; treated as unrestricted by the client.
  entitlements?: Entitlements;
  avatar: { avatarDataUrl?: string | null };
};

export const SessionAPI = {
  async getMe(opts?: { token?: string | null }): Promise<SessionMeResponseDTO> {
    try {
      const token = opts?.token ? String(opts.token).trim() : "";
      const response = await axiosInstance.get<SessionMeResponseDTO>(
        "/session/me",
        token ? { headers: { Authorization: `Bearer ${token}` } } : undefined
      );
      return response.data;
    } catch (error) {
      const apiError = handleAPIError(error);
      throw apiError;
    }
  }
};
